import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const BrandingContext = createContext(null);

function hexToHsl(hex) {
    if (!hex || !hex.startsWith("#")) return null;
    let h = hex.replace("#", "");
    if (h.length === 3)
        h = h
            .split("")
            .map((c) => c + c)
            .join("");
    const r = parseInt(h.substring(0, 2), 16) / 255;
    const g = parseInt(h.substring(2, 4), 16) / 255;
    const b = parseInt(h.substring(4, 6), 16) / 255;
    const max = Math.max(r, g, b),
        min = Math.min(r, g, b);
    let H = 0,
        S = 0;
    const L = (max + min) / 2;
    if (max !== min) {
        const d = max - min;
        S = L > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                H = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                H = (b - r) / d + 2;
                break;
            case b:
                H = (r - g) / d + 4;
                break;
        }
        H /= 6;
    }
    return `${Math.round(H * 360)} ${Math.round(S * 100)}% ${Math.round(L * 100)}%`;
}

export function applyBrandingVars(primaryHex, secondaryHex) {
    const r = document.documentElement;
    if (primaryHex) {
        const hsl = hexToHsl(primaryHex);
        if (hsl) r.style.setProperty("--wl-primary", hsl);
        r.style.setProperty("--wl-primary-hex", primaryHex);
    }
    if (secondaryHex) {
        r.style.setProperty("--wl-secondary-hex", secondaryHex);
    }
}

export function BrandingProvider({ children }) {
    const [tenant, setTenant] = useState({ agency: null, branding: null });

    useEffect(() => {
        const host = window.location.host;
        api.get(`/tenant/resolve`, { params: { host } })
            .then((r) => {
                setTenant(r.data || {});
                if (r.data?.branding) {
                    applyBrandingVars(
                        r.data.branding.primary_color,
                        r.data.branding.secondary_color,
                    );
                }
            })
            .catch(() => setTenant({ agency: null, branding: null }));
    }, []);

    return (
        <BrandingContext.Provider value={{ tenant, setTenant }}>
            {children}
        </BrandingContext.Provider>
    );
}

export function useBranding() {
    return useContext(BrandingContext) || { tenant: { agency: null, branding: null } };
}
